var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "flex w-full overflow-x-hidden",
      attrs: { id: "form-activity", autocomplete: "off" }
    },
    [
      _c(
        "div",
        { staticClass: "w-full p-2" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-col items-center mb-6" },
            [
              _c("div", { staticClass: "px-4 mb-6" }, [
                _c("img", {
                  staticClass:
                    "shadow rounded max-w-full h-auto align-middle border-none",
                  staticStyle: { width: "150px" },
                  attrs: {
                    alt: "...",
                    src: _vm.input.artwork
                      ? _vm.input.artwork
                      : _vm.imgPlaceholder
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col mb-2" }, [
                _c("p", { staticClass: "text-xs text-gray-700" }, [
                  _vm._v("We'll crop your image to a 900×900 square.")
                ]),
                _vm._v(" "),
                _vm.isImageTooSmall
                  ? _c("p", { staticClass: "text-xs text-orange-600 mt-1" }, [
                      _vm._v(
                        "Image is smaller than 900×900; quality may be reduced."
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.$v.input.artwork.$dirty && !_vm.$v.input.artwork.required
                ? _c(
                    "div",
                    { staticClass: "flex flex-col mb-2" },
                    [
                      _vm.$v.input.artwork.$dirty &&
                      !_vm.$v.input.artwork.required
                        ? _c("text-error", {
                            attrs: { text: "Please select album artwork." }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  !_vm.input.artwork
                    ? _c("Button", {
                        attrs: { label: "Browse File" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "any",
                              fn: function() {
                                return [
                                  _c("input", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      position: "absolute",
                                      left: "0",
                                      top: "0",
                                      opacity: "0",
                                      cursor: "pointer",
                                      "z-index": "2"
                                    },
                                    attrs: {
                                      type: "file",
                                      name: "profile_picture",
                                      accept: "image/*"
                                    },
                                    on: { change: _vm.onFileChange }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1048279932
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.input.artwork
                    ? _c("Button", {
                        attrs: { label: "Cancel", variant: "default" },
                        on: { clicked: _vm.changeImage }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("ImageCropModal", {
                attrs: {
                  show: _vm.showCropModal,
                  imageSrc: _vm.pendingImageSrc
                },
                on: { cropped: _vm.onCropCropped, cancel: _vm.onCropCancel }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "form-item",
            {
              staticClass: "mt-6",
              attrs: { label: "Album Name", required: true }
            },
            [
              _c("Input", {
                attrs: {
                  placeholder: "ex. Album Name",
                  error:
                    _vm.$v.input.albumName.$dirty &&
                    (!_vm.$v.input.albumName.required ||
                      !_vm.$v.input.albumName.maxLength),
                  maxlength: "100"
                },
                model: {
                  value: _vm.input.albumName,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "albumName", $$v)
                  },
                  expression: "input.albumName"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col pt-2" },
                [
                  _vm.$v.input.albumName.$dirty &&
                  !_vm.$v.input.albumName.required
                    ? _c("text-error", {
                        attrs: { text: "Please fill Album Name." }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.input.albumName.$dirty &&
                  !_vm.$v.input.albumName.maxLength
                    ? _c("text-error", {
                        attrs: {
                          text: "Max length Album name is 100 character."
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-item",
            {
              staticClass: "mt-6",
              attrs: { label: "Description", required: true }
            },
            [
              _c(
                "div",
                { staticClass: "relative" },
                [
                  _c("TextArea", {
                    attrs: {
                      placeholder: "Description Video",
                      error:
                        _vm.$v.input.albumDescription.$dirty &&
                        (!_vm.$v.input.albumDescription.required ||
                          !_vm.$v.input.albumDescription.maxLength),
                      rows: "5"
                    },
                    model: {
                      value: _vm.input.albumDescription,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "albumDescription", $$v)
                      },
                      expression: "input.albumDescription"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "absolute right-0 text-xs",
                      staticStyle: { bottom: "15px", right: "15px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.input.albumDescription.length) +
                          "/" +
                          _vm._s(_vm.maxLengthDesc)
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col pt-2" },
                [
                  _vm.$v.input.albumDescription.$dirty &&
                  !_vm.$v.input.albumDescription.required
                    ? _c("text-error", {
                        attrs: { text: "Please fill the Description." }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.input.albumDescription.$dirty &&
                  !_vm.$v.input.albumDescription.maxLength
                    ? _c("text-error", {
                        attrs: {
                          text:
                            "Max length description channel is 1000 character"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "form-item",
            { staticClass: "mt-6", attrs: { label: "Year", required: true } },
            [
              _c("Input", {
                attrs: {
                  placeholder: "ex. 2020",
                  error:
                    _vm.$v.input.year.$dirty &&
                    (!_vm.$v.input.year.required ||
                      !_vm.$v.input.year.maxLength ||
                      !_vm.$v.input.year.numeric),
                  maxlength: "100"
                },
                model: {
                  value: _vm.input.year,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "year", $$v)
                  },
                  expression: "input.year"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col pt-2" },
                [
                  _vm.$v.input.year.$dirty && !_vm.$v.input.year.required
                    ? _c("text-error", {
                        attrs: { text: "Please fill Year Album." }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.input.year.$dirty && !_vm.$v.input.year.maxLength
                    ? _c("text-error", {
                        attrs: { text: "Max length Year Album is 4 character." }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.input.year.$dirty && !_vm.$v.input.year.numeric
                    ? _c("text-error", {
                        attrs: { text: "Please fill Year Album with number." }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("form-item", {
            staticClass: "mt-6",
            attrs: { label: "Category", required: true },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _vm._l(_vm.$v.input.genreList.$each.$iter, function(
                          v,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: "genre-" + index,
                              staticClass: "flex flex-col mb-4"
                            },
                            [
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: v.id.$model,
                                        expression: "v.id.$model"
                                      }
                                    ],
                                    staticClass:
                                      "border border-1 px-3 py-2 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150",
                                    class: {
                                      "border-red-500":
                                        v.id.$dirty && !v.id.required
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          v.id,
                                          "$model",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: { disabled: "" },
                                        domProps: { value: null }
                                      },
                                      [_vm._v("Select Song Category")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.listGenreSong, function(
                                      item,
                                      key
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          attrs: { "v-text": item.name },
                                          domProps: { value: item.id }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.name) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                index > 0
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-10 ml-2 p-1 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeCategory(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "text-white",
                                          attrs: { icon: ["fa", "trash-alt"] }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  v.id.$dirty && !v.id.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please choose category"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex w-full justify-center" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer\n                        hover:bg-blue-700 hover:text-blue-100\n                        text-blue-700\n                          border duration-200 ease-in-out\n                        border-blue-600 transition",
                                on: { click: _vm.addCategory }
                              },
                              [_vm._v("Add another category")]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            staticClass: "mt-6",
            attrs: { label: "Language", required: _vm.isArtist },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          filterable: "",
                          placeholder: "Select Language"
                        },
                        model: {
                          value: _vm.input.language,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "language", $$v)
                          },
                          expression: "input.language"
                        }
                      },
                      _vm._l(_vm.dataLanguages, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.language.$dirty &&
                        !_vm.$v.input.language.required
                          ? _c("text-error", {
                              attrs: { text: "Please choose language." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "form-item",
            { staticClass: "mt-6", attrs: { label: "Composer (optional)" } },
            [
              _c("Input", {
                attrs: {
                  placeholder: "ex. Composer name(s)",
                  maxlength: "255"
                },
                model: {
                  value: _vm.input.composer,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "composer", $$v)
                  },
                  expression: "input.composer"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("form-item", {
            staticClass: "mt-6",
            attrs: {
              label: "Subscription",
              info:
                "Turn on and off subscription setting to monetize this content by streaming number."
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "label",
                      {
                        staticClass: "flex items-center cursor-pointer",
                        attrs: { for: "toogleSubsAlbum" }
                      },
                      [
                        _c("div", { staticClass: "relative" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.input.isSubscription,
                                expression: "input.isSubscription"
                              }
                            ],
                            staticClass: "hidden",
                            attrs: { id: "toogleSubsAlbum", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.input.isSubscription)
                                ? _vm._i(_vm.input.isSubscription, null) > -1
                                : _vm.input.isSubscription
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.input.isSubscription,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.input,
                                        "isSubscription",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.input,
                                        "isSubscription",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.input, "isSubscription", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ml-3 text-gray-700 font-medium" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.input.isSubscription ? "On" : "Off"
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            staticClass: "mt-6",
            attrs: {
              label: "Sell Album",
              info:
                "toggle between free and paid to monetize this content by selling it"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "label",
                      {
                        staticClass: "flex items-center cursor-pointer",
                        attrs: { for: "toogleBAlbum" }
                      },
                      [
                        _c("div", { staticClass: "relative" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.input.isPaid,
                                expression: "input.isPaid"
                              }
                            ],
                            staticClass: "hidden",
                            attrs: { id: "toogleBAlbum", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.input.isPaid)
                                ? _vm._i(_vm.input.isPaid, null) > -1
                                : _vm.input.isPaid
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.input.isPaid,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.input,
                                        "isPaid",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.input,
                                        "isPaid",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.input, "isPaid", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ml-3 text-gray-700 font-medium" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.input.isPaid ? "Paid" : "Free") +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.input.isPaid
            ? _c(
                "form-item",
                {
                  staticClass: "mt-6",
                  attrs: {
                    label: "Album Price (USD)",
                    required: _vm.input.isPaid
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "inline-flex w-full gap-4 items-center" },
                    [
                      _vm._v("\n        $ "),
                      _c("Input", {
                        attrs: {
                          placeholder: "ex. 5",
                          error:
                            _vm.$v.input.price.$dirty &&
                            (!_vm.$v.input.price.required ||
                              !_vm.$v.input.price.decimal)
                        },
                        model: {
                          value: _vm.input.price,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "price", $$v)
                          },
                          expression: "input.price"
                        }
                      }),
                      _vm._v(
                        " = " + _vm._s(_vm.creditPrice) + " Credits\n      "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col pt-2" },
                    [
                      _vm.$v.input.price.$dirty && !_vm.$v.input.price.required
                        ? _c("text-error", {
                            attrs: { text: "Please fill Album Price." }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input.price.$dirty && !_vm.$v.input.price.decimal
                        ? _c("text-error", {
                            attrs: {
                              text: "Please fill Album Price with number."
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.input.isPaid && _vm.input.price != 0
            ? _c("div", { staticClass: "flex w-full mt-6" }, [
                _c(
                  "div",
                  { staticClass: "w-1/2" },
                  [
                    _c("form-item", { attrs: { label: "MusicVerse Cut" } }, [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v("$ " + _vm._s(_vm.priceMusicVerse))
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-1/2" },
                  [
                    _c("form-item", { attrs: { label: "Artist Cut" } }, [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v("$ " + _vm._s(_vm.priceArtistMusicVerse))
                      ])
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form-item",
            {
              staticClass: "mt-6",
              attrs: {
                label: "Sell Song Individually?",
                info:
                  "When you upload a song, you can put price individually in each track"
              }
            },
            [
              _c("Select", {
                attrs: {
                  "empty-label": "",
                  data: [
                    { value: 0, label: "No" },
                    { value: 1, label: "Yes" }
                  ]
                },
                model: {
                  value: _vm.input.isSellSongIndividually,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "isSellSongIndividually", $$v)
                  },
                  expression: "input.isSellSongIndividually"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-item",
            { staticClass: "mt-6", attrs: { label: "Copyright" } },
            [
              _c(
                "label",
                {
                  staticClass: "flex items-center cursor-pointer",
                  attrs: { for: "toogleCopyRightAlbum" }
                },
                [
                  _c("div", { staticClass: "relative" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.input.copyRight,
                          expression: "input.copyRight"
                        }
                      ],
                      staticClass: "hidden",
                      attrs: { id: "toogleCopyRightAlbum", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.input.copyRight)
                          ? _vm._i(_vm.input.copyRight, null) > -1
                          : _vm.input.copyRight
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.input.copyRight,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.input,
                                  "copyRight",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.input,
                                  "copyRight",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.input, "copyRight", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-3 text-gray-700 font-medium" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.input.copyRight ? "Yes" : "No") +
                        "\n        "
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.input.copyRight
            ? _c(
                "form-item",
                {
                  staticClass: "mt-6",
                  attrs: {
                    label: "Upload Copyright",
                    required: _vm.input.copyRight
                  }
                },
                [
                  !_vm.input.copyRightFile
                    ? _c("input", {
                        staticClass:
                          "block border border-grey-light w-full p-3 rounded",
                        attrs: {
                          type: "file",
                          name: "copyright_file",
                          accept:
                            "image/*,application/pdf,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
                        },
                        on: { change: _vm.onFileChangeCopyRight }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.input.copyRightFile
                    ? _c("div", { staticClass: "flex" }, [
                        _c(
                          "span",
                          { staticClass: "mr-2 text-gray-700 font-medium" },
                          [_vm._v(_vm._s(_vm.copyRightFileName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          { on: { click: _vm.changeCopyRight } },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "times-circle"] }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col pt-2" },
                    [
                      _vm.$v.input.copyRightFile.$dirty &&
                      !_vm.$v.input.copyRightFile.required
                        ? _c("text-error", {
                            attrs: { text: "Please select copyright file." }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap px-4 mb-2 mt-8" }, [
            _vm._m(3),
            _vm._v(" "),
            _vm.isErrorMusicCount
              ? _c("p", { staticClass: "text-red-500 text-xs italic w-full" }, [
                  _vm._v("You must upload at least 1 song.")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.input.musics.length > 0
            ? _c(
                "div",
                _vm._l(_vm.$v.input.musics.$each.$iter, function(v, index) {
                  return _c(
                    "div",
                    { staticClass: "flex flex-col mb-2" },
                    [
                      _c("div", { staticClass: "flex flex-wrap mt-4 mb-2" }, [
                        _c("div", { staticClass: "px-4 mb-1 md:mb-0" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block uppercase tracking-wide text-gray-700  font-bold mb-2"
                            },
                            [
                              _vm._v(
                                "\n              Track " +
                                  _vm._s(parseInt(index) + 1) +
                                  " "
                              ),
                              _c("span", { staticClass: "text-red-500" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-6 ml-2 p-1 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeTracks(index)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "text-white",
                                    attrs: {
                                      size: "1x",
                                      icon: ["fa", "trash-alt"]
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("form-item", {
                        staticClass: "mt-6",
                        attrs: { label: "Track Number", required: true },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value:
                                            _vm.input.musics[index]
                                              .track_number,
                                          expression:
                                            "input.musics[index].track_number",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      staticClass:
                                        "block border border-grey-light w-full p-3 rounded mb-4",
                                      attrs: { type: "text" },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.input.musics[index],
                                              "track_number",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function($event) {
                                            return _vm.changeTrackNumber(
                                              $event,
                                              index
                                            )
                                          }
                                        ]
                                      }
                                    },
                                    _vm._l(_vm.listTrackNumbers, function(
                                      item,
                                      key
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          attrs: { "v-text": item },
                                          domProps: { value: item }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "form-item",
                        {
                          staticClass: "mt-6",
                          attrs: { label: "Name", required: true }
                        },
                        [
                          _c("Input", {
                            attrs: {
                              placeholder: "Song Name",
                              error: v.title.$dirty && !v.title.required
                            },
                            model: {
                              value: v.title.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  v.title,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "v.title.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col pt-2" },
                            [
                              v.title.$dirty && !v.title.required
                                ? _c("text-error", {
                                    attrs: { text: "Please fill Song Name." }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "form-item",
                        { staticClass: "mt-6", attrs: { label: "File" } },
                        [
                          _vm.input.musics[index].fileMusicPreview
                            ? _c("div", { staticClass: "flex" }, [
                                _c(
                                  "audio",
                                  {
                                    ref: "audioFile",
                                    refInFor: true,
                                    attrs: { controls: "controls" }
                                  },
                                  [
                                    _c("source", {
                                      attrs: {
                                        src:
                                          _vm.input.musics[index]
                                            .fileMusicPreview,
                                        type: "audio/mp3"
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-item",
                        { staticClass: "mt-6", attrs: { label: "Lyric" } },
                        [
                          !v.lyric.$model
                            ? _c("input", {
                                staticClass:
                                  "block border border-grey-light w-full p-3 rounded",
                                attrs: {
                                  type: "file",
                                  name: "lyrics_file",
                                  accept: ".srt"
                                },
                                on: {
                                  change: function($event) {
                                    v.lyricFile.$model = $event.target.files[0]
                                    v.lyric.$model = v.lyricFile.$model.name
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          v.lyric.$model
                            ? _c("div", { staticClass: "flex" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "mr-2 text-gray-700 font-medium"
                                  },
                                  [_vm._v(_vm._s(v.lyric.$model))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        v.lyric.$model = null
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fas", "times-circle"] }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col pt-2" },
                            [
                              v.lyricFile.$dirty && !v.lyricFile.mustSrt
                                ? _c("text-error", {
                                    attrs: { text: "File type must be .srt" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-item",
                        {
                          staticClass: "mt-6",
                          attrs: { label: "Language", required: _vm.isArtist }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-full",
                              attrs: {
                                filterable: "",
                                placeholder: "Select Language"
                              },
                              model: {
                                value: v.language.$model,
                                callback: function($$v) {
                                  _vm.$set(v.language, "$model", $$v)
                                },
                                expression: "v.language.$model"
                              }
                            },
                            _vm._l(_vm.dataLanguages, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col pt-2" },
                            [
                              v.language.$dirty &&
                              !v.language.required &&
                              _vm.isArtist
                                ? _c("text-error", {
                                    attrs: { text: "Please choose language." }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "form-item",
                        {
                          staticClass: "mt-6",
                          attrs: { label: "Composer (optional)" }
                        },
                        [
                          _c("Input", {
                            attrs: {
                              placeholder: "ex. Composer name(s)",
                              maxlength: "255"
                            },
                            model: {
                              value: v.composer.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  v.composer,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "v.composer.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "form-item",
                        {
                          staticClass: "mt-6",
                          attrs: { label: "Original or Cover Song" }
                        },
                        [
                          _c("Select", {
                            attrs: {
                              "empty-label": "",
                              data: [
                                { value: 0, label: "Original" },
                                { value: 1, label: "Cover" }
                              ]
                            },
                            model: {
                              value: v.is_cover.$model,
                              callback: function($$v) {
                                _vm.$set(v.is_cover, "$model", $$v)
                              },
                              expression: "v.is_cover.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.input.musics[index].is_cover === 1
                        ? _c(
                            "form-item",
                            {
                              staticClass: "mt-6",
                              attrs: {
                                label: "Original Artist Name",
                                required: _vm.input.musics[index].is_cover === 1
                              }
                            },
                            [
                              _c("Input", {
                                attrs: {
                                  placeholder: "Original artist name",
                                  maxlength: "255"
                                },
                                model: {
                                  value: v.original_artist_name.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      v.original_artist_name,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "v.original_artist_name.$model"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.isErrorCoverArtist[index]
                                    ? _c("text-error", {
                                        attrs: {
                                          text:
                                            "Please fill Original Artist Name for a Cover song."
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.input.musics[index].is_cover === 1
                        ? _c(
                            "form-item",
                            {
                              staticClass: "mt-6",
                              attrs: { label: "Original Artist Info" }
                            },
                            [
                              _c("TextArea", {
                                attrs: {
                                  placeholder:
                                    "Original artist info (optional)",
                                  rows: "3"
                                },
                                model: {
                                  value: v.original_artist_info.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      v.original_artist_info,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "v.original_artist_info.$model"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.input.isSellSongIndividually
                        ? _c(
                            "form-item",
                            {
                              staticClass: "mt-6",
                              attrs: { label: "Song Price" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "inline-flex w-full gap-4 items-center"
                                },
                                [
                                  _vm._v("\n            $ "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: v.price.$model,
                                        expression: "v.price.$model"
                                      }
                                    ],
                                    staticClass:
                                      "border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150",
                                    attrs: { placeholder: "ex. 5" },
                                    domProps: { value: v.price.$model },
                                    on: {
                                      keyup: function($event) {
                                        return _vm.convertPrice(index)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          v.price,
                                          "$model",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    " = " +
                                      _vm._s(
                                        _vm.input.musics[index].price_dollar
                                      ) +
                                      " Credits\n          "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap -mx-3 mt-4 mb-2" }, [
            _c(
              "div",
              {
                ref: "dragDrop",
                staticClass:
                  "relative drag-drop px-3 w-full upload-btn-wrapper",
                on: {
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.onDrop($event)
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  dragenter: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  dragleave: function($event) {
                    $event.preventDefault()
                    _vm.dragover = false
                  }
                }
              },
              [
                _c("input", {
                  attrs: { type: "file", name: "fileSong" },
                  on: { change: _vm.onFileUploadSong }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "absolute drag-drop-content flex flex-col w-full"
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon-drag-drop",
                      attrs: { icon: ["fa", "cloud-upload-alt"] }
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "mb-4" }, [
                      _vm._v("Click or Drag Your Files Here")
                    ])
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex px-4 mb-2" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700  font-bold mb-2"
        },
        [
          _vm._v("\n        Cover Image "),
          _c("span", { staticClass: "text-red-500" }, [_vm._v("*")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex px-4 mb-2 mt-8" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700  font-bold mb-2"
        },
        [_vm._v("\n        Metadata\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-wrap px-4 mb-2 mt-8" }, [
      _c(
        "label",
        {
          staticClass:
            "block uppercase tracking-wide text-gray-700  font-bold mb-2"
        },
        [_vm._v("\n        Monetization\n      ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass:
          "block uppercase tracking-wide text-gray-700  font-bold mb-2"
      },
      [
        _vm._v("\n        Upload Tracks "),
        _c("span", { staticClass: "text-red-500" }, [_vm._v("*")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e030070", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e030070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Album/AddAlbum.vue
// module id = null
// module chunks = 